import styled from "styled-components";
import NavItem from "../../../../default-styles/NavItem/NavItem.style.js";
import { SidebarItemProps } from "./SidebarItem.types.js";

type StyledSidebarItemProps = Pick<SidebarItemProps, "disabled"> & {
    selected: boolean;
};

export const StyledSidebarItem = styled(NavItem)<StyledSidebarItemProps>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    user-select: none;
    flex: 1 1 auto;
`;
